import clsx from "clsx";

import { memo } from "react";
import { useContent } from "contexts/contentContext/contentContext";

import styles from "./authTitle.module.scss";

interface AuthTitleI extends React.HTMLAttributes<HTMLHeadingElement> {
  type: "sign-in" | "sign-up" | "sign-in-as-root-user";
}

const AuthTitle = memo((props: AuthTitleI) => {
  const { className, type, ...restProps } = props;

  const { getTextByKey } = useContent();

  const textKey = type === "sign-up" ? "signup" : type;

  return (
    <h1 className={clsx(styles.wrapper, className)} {...restProps}>
      {getTextByKey(textKey)}
    </h1>
  );
});

export default AuthTitle;
